export const ethnicity = [
    {
        value: '2',
        label: 'White',
        option: 'A',
        instruction: '',
    },
    {
        value: '3',
        label: 'Mixed / multiple ethnic background',
        option: 'B',
        instruction: '',
    },
    {
        value: '4',
        label: 'Asian / Asian British',
        option: 'C',
        instruction: '',
    },
    {
        value: '5',
        label: 'Black / African / Caribbean / Black British',
        option: 'D',
        instruction: '',
    },
    {
        value: '1',
        label: 'Other ethnic group',
        option: 'E',
        instruction: '',
    },
    {
        value: '0',
        label: 'Prefer not to say',
        option: 'F',
        instruction: '',
    },
];
